import React from 'react';
import { Divider, Grid } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { entityType } from '../../constants';
import { ChemicalProduct, Inventory } from '../../routes';
import Tile from '../common/Tile';
import { history } from '../../store';

const FavoriteTiles = ({ t, favoriteDataViewList }) => {
  const groupedFavorites = entityTypeParam => {
    const groupedFavoriteDataViewList =
      favoriteDataViewList &&
      favoriteDataViewList.length > 0 &&
      favoriteDataViewList.filter(dv => dv.entityType === entityTypeParam);
    return (
      <>
        {groupedFavoriteDataViewList && groupedFavoriteDataViewList.length > 0 && (
          <Divider horizontal>
            {t(`home.option.favorite.${entityTypeParam}.dataview.divider`)}
          </Divider>
        )}
        <Grid centered className="favoriteTiles">
          {groupedFavoriteDataViewList &&
            groupedFavoriteDataViewList.map(dv => {
              const baseName =
                entityTypeParam === entityType.inventory
                  ? Inventory.baseName
                  : ChemicalProduct.baseName;
              return (
                <Tile
                  id={`favoriteDataview-${dv.key}`}
                  key={`favoriteDataview-${dv.key}`}
                  title={dv.text}
                  icon="star"
                  iconSize="small"
                  onClick={() =>
                    history.push({
                      pathname: `${baseName}/overview/entity/`,
                      state: { newSelectedDataViewId: dv.key }
                    })
                  }
                />
              );
            })}
        </Grid>
      </>
    );
  };

  return (
    <>
      {groupedFavorites(entityType.inventory)}
      {groupedFavorites(entityType.product)}
    </>
  );
};

Tile.defaultProps = {
  onClick: () => {}
};

export default withTranslation()(FavoriteTiles);
